import React from 'react';
import { Modal } from 'react-bootstrap';
import Add_Service_Provider from 'components/widgets/forms/serviceProviders/Add_Service_Provider';

export default function AddServiceProvider(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add Service Provider</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Add_Service_Provider {...props} />
        </Modal.Body>
      </Modal>
    </div>
  );
}
